import { initialCheckoutState, CHECKOUT_ACTIONS } from './checkout.types'

export function checkoutSliceReducer(state = initialCheckoutState, { type, payload }) {
  switch (type) {
    case CHECKOUT_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case CHECKOUT_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CHECKOUT_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    case CHECKOUT_ACTIONS.SET_VALIDATION_STATUS:
      return { ...state, validationStatus: payload }

    case CHECKOUT_ACTIONS.SET_VALIDATION_ERRORS:
      return { ...state, validationErrors: payload }

    case CHECKOUT_ACTIONS.CLEAR_VALIDATION_ERRORS:
      return { ...state, validationErrors: [] }

    default:
      return state
  }
}
